import { ReactElement } from "react";

import { Circle } from "@chakra-ui/react";

import { Button, ButtonProps } from "ui/Button/Button";
import { Modal, ModalProps } from "ui/Modal/Modal";
import { HeaderS } from "ui/Typography/Typography";
import { isNotNullNorUndefined } from "utils/tsHelpers";

export type CtaModalProps = {
  title?: string;
  body: ReactElement;
  headerIcon?: ReactElement;
  ctaLabel: string;
  onClickCta: () => void;
  hideCloseButton?: boolean;
  variant?: ButtonProps["variant"];
} & Pick<ModalProps, "onClose" | "isOpen">;

export function CtaModal({
  isOpen = false,
  onClose,
  title,
  body,
  ctaLabel,
  onClickCta,
  hideCloseButton = false,
  headerIcon,
  variant = "primary",
}: CtaModalProps) {
  return (
    <Modal
      trapFocus={false}
      closeOnOverlayClick={false}
      isCentered
      isOpen={isOpen}
      onClose={onClose}
    >
      <Modal.Content marginX="s300">
        {headerIcon && (
          <Circle mt="s300" size="120px" marginX="auto" bg="grey.100">
            {headerIcon}
          </Circle>
        )}
        {isNotNullNorUndefined(title) && (
          <Modal.Header textAlign="center" paddingX="s200">
            <HeaderS>{title}</HeaderS>
          </Modal.Header>
        )}
        {!hideCloseButton && <Modal.CloseButton size="lg" />}
        <Modal.Body paddingY="0" paddingX="s200">
          {body}
        </Modal.Body>
        <Modal.Footer padding="s200">
          <Button
            onClick={onClickCta}
            isFullWidth
            variant={variant}
            size="lg"
            data-testid="ctaButton"
          >
            {ctaLabel}
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
}
